// @packages
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import { globalUI } from '../../core';

// @styles
import styles from './styles';

const FanWizardItem = ({
    classes,
    description,
    id,
    imageSource,
    title,
    url
}) => (
    <Card id={`${id}-card`} className={classes.fanItem} elevation={3}>
        <CardActionArea onClick={() => globalUI.navigateToUrl(url)}>
            <CardMedia
                className={classes.media}
                classes={{
                    img: classes.img
                }}
                component="img"
                src={imageSource}
                //title="Contemplative Reptile"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                    {title}
                </Typography>
                {
                    description && (
                        <Typography variant="body2" color="textSecondary" component="p">
                            {description}
                        </Typography>
                    )
                }
            </CardContent>
        </CardActionArea>
    </Card>
);

FanWizardItem.propTypes = {
    classes: PropTypes.object.isRequired,
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    imageSource: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

FanWizardItem.defaultProps = {
    description: null
};

export default withStyles(styles)(FanWizardItem);
